import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudDialogModule,
	FreudInputTextAreaModule,
	FreudLoaderModule,
	FreudMultiSelectModule,
	FreudToastModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { ProfessionalService } from 'app/services/professional.service';

import { ContactBulkMessageComponent } from './contact-bulk-message.component';

@NgModule({
	declarations: [ContactBulkMessageComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudDialogModule,
		FreudMultiSelectModule,
		FreudInputTextAreaModule,
		FreudButtonModule,
		FormsModule,
		FreudToastModule,
		FreudLoaderModule,
	],
	exports: [ContactBulkMessageComponent],
	providers: [ProfessionalService],
})
export class ContactBulkMessageModule {}
